(function() {
  if(!globalMediaQueryMobile.matches) {
    let reports = document.querySelectorAll('.report___article_wrap');

    document.addEventListener('DOMContentLoaded', calcHeight);
    window.addEventListener('resize', calcHeight);
  
    function calcHeight() {
      g_Arr(reports).forEach(function(report) {
        let reportHeight = report.getBoundingClientRect().height;
        // console.log(reportHeight);
        report.style.height = reportHeight + 'px';
      });
    }
  }
})();